import api from "../../config/client.axios.api";

export const getRevenueEachMonthApi = async (
  year: number,
  accountId?: string
) => {
  const response = await api.get(`/history/get-revenue-each-month`, {
    params: {
      accountId: accountId && accountId,
      year: year,
    },
  });
  return response.data;
};
